import { SearchFormState } from './reducers';
import { createSearchParameters } from '../utils';
import { getPromoCode } from './promoCode/selectors';
import { getPassengersConfig } from './passengersConfig/selectors';
import { AviaSearchParameters } from '@websky/graphql';
import { Currency } from '../../enums';

const getPassengers = (state: SearchFormState) => state.passengers;
const getSegments = (state: SearchFormState) => state.segments;
export const getRedeemMiles = (state: SearchFormState) => state?.redeemMiles;

export const getSearchParameters = (state: SearchFormState): AviaSearchParameters => {
	const searchParams = createSearchParameters(
		getPassengers(state),
		getSegments(state),
		getPassengersConfig(state),
		getPromoCode(state),
		getRedeemMiles(state)
	);

	if (state.foreignCard) {
		searchParams.currency = Currency.KZT;
	}

	return searchParams;
};
